// extracted by mini-css-extract-plugin
export default {"nomenclature":"Nomenclature_nomenclature__BBWrU","nomenclature_description":"Nomenclature_nomenclature_description__BbKy0"};